export const Choices = {
    red: "red",
    black: "black",
    diamonds: "diamonds",
    spades: "spades",
    hearts: "hearts",
    clubs: "clubs",
};

export enum TabsValue {
    redBlack,
    suits,
}

export const SuitKeys = ["hearts", "diamonds", "clubs", "spades"];
export const SuitOrder = [1, 0, 3, 2];
export const ChoiceSuitOrder = ["diamonds", "hearts", "spades", "clubs"];
